import { Component, OnInit } from '@angular/core';
import { Representante } from './representantes.model';
import { Router } from '@angular/router';

// services
import { EventService } from 'src/app/core/service/event.service';
import { RepresentanteService } from './representantes.service';


// constants
import { EventType } from 'src/app/core/constants/events';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-new-representante',
  templateUrl: './new-representante.component.html',
  styleUrls: ['./new-representante.component.scss']
})
export class NewRepresentanteComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private representanteService: RepresentanteService,
    private router: Router) { }

    model = {
      nombre: '',
      apellidos: '',
      email: '',
      telefono: '',
      nivel_acceso: 'REPRESENTANTE'
    }

  ngOnInit(): void {
    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: 'Nuevo representante',
        breadCrumbItems: [{ label: 'Representantes', path: '.' }, { label: 'Nuevo representante', path: '.', active: true }]
      }
    );
  }

  onSubmit(form: NgForm) {

    let nivelAcceso = form.value.nivel_acceso;
    let esRepresentante = false;

    // Si el nivel de acceso es REPRESENTANTE, el nivel_acceso debe ser USUARIO y es_representante = 1
    if (nivelAcceso === 'REPRESENTANTE') {
        nivelAcceso = 'USUARIO';
        esRepresentante = true;
    }

    const usuario: Representante = {
      nombre: form.value.nombre,
      apellidos: form.value.apellidos,
      email: form.value.email,
      telefono: form.value.telefono,
      validado: false,
      activo: true,
      nivel_acceso: nivelAcceso, // Ajusta el valor de nivel_acceso
      es_arbitro: false,
      es_representante: esRepresentante // Añade esta línea
    };


    
    this.representanteService.newRepresentante(usuario)
      .subscribe(res => {
        this.router.navigate(['/representantes']);
      })
    
  }

}
